<template>
    <div>
        <div class="card-header pt-0">
            <div class="row justify-content-between align-items-center mb-0 mb-md-2 pb-0 pb-1">
                <div class="col-12 col-lg-4">
                    <SearchComponent v-model="filters.search" />
                </div>
                <div class="col-12 col-lg-6 mt-3 mt-md-0 text-right">
                    <b-button v-if="!footer.ocultar_pack" 
                              :to="{ name: 'back.packs-events.index' }"
                              class="mr-0 mr-md-2 mb-2 packs-eventos"
                    >
                        Packs de eventos
                    </b-button>
                    <b-button
                        :to="{ name: 'back.events.crear' }"
                        class="crearEvento mb-2"
                        v-if="permisos['eventos.crear']"
                    >
                        CREAR EVENTO
                    </b-button>
                </div>
            </div>
        </div>
        <div class="card-body" v-if="!loading">
            <template v-for="(event, index) in events.data">
                <div :key="index">
                    <div class="row mb-2">
                        <div class="col12 col-md-6">
                            <div class="mb-2">
                                <strong>{{ event.codigo }}</strong> -
                                <span v-if="event.status == 1" class="mr-2">
                                    <i class="text-green fas fa-check-circle"></i>
                                </span>
                                <span v-if="event.status == 0" class="mr-2">
                                    <i class="text-warning fas fa-pause-circle"></i>
                                </span>
                                <span v-if="event.tiene_recinto" class="mr-2">
                                    <i class="fas fa-map-marker-alt"></i>
                                </span> 
                                - {{ event.nombre_completo }}
                            </div>
                        </div>
                        <div class="col-12 col-md-6 text-right">
                            <div>
                                <button v-if="(permisos['eventos.editar'] || permisos['eventos.crear']) && !event.compartido" class="btn btn-secondary ml-2" v-on:click.prevent="showModalCambiarImagen(event)">
                                    Cambiar imagen
                                </button>
                                <router-link 
                                    :to="{
                                        name: 'back.events.compania',
                                        params: { evento_id: event.id },
                                    }" 
                                    class="btn btn-primary ml-2" 
                                    id="compania"
                                    v-if="permisos['eventos.editar'] && !event.compartido"
                                >
                                    <i class="fas fa-users"></i> Compañia
                                </router-link>
                                <router-link 
                                    :to="{
                                        name: 'back.events.informe',
                                        params: { id: event.id },
                                    }" 
                                    class="btn btn-primary ml-2" 
                                    v-if="permisos['eventos.informe']"
                                >
                                    <i class="fas fa-chart-bar"></i> Informe
                                </router-link>
                                <button 
                                    type="button" 
                                    name="button" 
                                    class="btn btn-primary ml-2" 
                                    v-if="!event.compartido"
                                    @click="expandir(index)"
                                >
                                    <i class="far fa-calendar-alt"></i> Sesiones ({{ event.numero_sesiones }})
                                </button>

                                <OpcionesDropdownComponent 
                                    v-if="(permisos['eventos.editar'] || permisos['eventos.control_accesos']) && !event.compartido"
                                    v-bind:options="[
                                        ...(permisos['taquilleros.gestion'] & !permisos['eventos.editar']
                                            ? [
                                                {
                                                    to: {
                                                        name: 'back.events.fields',
                                                        params: { evento_id: event.id },
                                                    },
                                                    label: 'Campos personalizados',
                                                },
                                            ]
                                            : []),
                                        ...(permisos['eventos.editar'] && permisos['taquilleros.gestion']
                                            ? [
                                                {
                                                    to: {
                                                        name: 'back.events.editar',
                                                        params: { evento_id: event.id },
                                                    },
                                                    label: 'Editar',
                                                },
                                                {
                                                    to: {
                                                        name: 'back.events.fields',
                                                        params: { evento_id: event.id },
                                                    },
                                                    label: 'Campos personalizados',
                                                },
                                                {
                                                    to: {
                                                        name: 'back.events.puertas.index',
                                                        params: { evento_id: event.id },
                                                    },
                                                    label: 'Puertas',
                                                },
                                                {
                                                    type: 'action',
                                                    action: () => showModal('borrar-' + event.id),
                                                    label: 'Borrar',
                                                },    
                                            ]
                                            : []),
                                    ]" 
                                    class="ml-2"
                                />
                            </div>
                        </div>
                    </div>
                    <DeleteEventModal :evento="event" v-on:close="closeModal"/>
                </div>
                <div :key="'2-' + index" v-show="expand.indexOf(index) >= 0">
                    <div class="row mb-5">
                        <div class="col-12 pdng-right">
                            <hr />
                            <button class="float-right btn btn-primary" @click.prevent="showCrearSesion(event)" v-if="permisos['eventos.crear']">
                                Crear sesion
                            </button>
                        </div>
                        <div class="col-12 mt-3">
                            <div>
                                <template v-for="(sesion, index) in event.sesiones">
                                    <div :key="index" class="row color-gray">
                                        <div class="col-12 col-md-2 mb-2">
                                            <span 
                                                v-if="sesion.fecha_provisional == 1" 
                                                class="mr-2"
                                            >
                                                <i class="text-danger fas fa-question-circle"></i>
                                            </span>
                                            {{ sesion.fecha }}
                                        </div>
                                        <div class="col-12 col-md-10 text-right">
                                            <button class="btn btn-secondary ml-2 mb-2" @click="getUrlEvent(event, sesion)">
                                                <i class="fas fa-copy"></i> Copiar url
                                            </button>
                                            <button v-if="permisos['eventos.vender'] && !isTaquilleroVisitante" class="btn btn-secondary ml-2 mb-2" @click="openTestTab(event, sesion)">
                                                <i class="fas fa-vial"></i> Test venta
                                            </button>
                                            <router-link 
                                                :to="{
                                                    name: 'back.events.sesion.bloquear-asientos',
                                                    params: { evento_id: event.id, sesion_id: sesion.id },
                                                }" 
                                                class="btn btn-secondary ml-2 mb-2" 
                                                v-if="permisos['eventos.editar']"
                                            >
                                                <i class="fas fa-lock"></i> Gestor butacas
                                            </router-link>
                                            <router-link 
                                                :to="{
                                                    name: 'back.events.venta',
                                                    params: { evento_id: event.id, sesion_id: sesion.id },
                                                }" 
                                                class="btn btn-secondary ml-2 mb-2" 
                                                v-if="permisos['eventos.vender']"
                                            >
                                                <i class="fas fa-euro-sign"></i> Venta
                                            </router-link>
                                            <router-link 
                                                :to="{
                                                    name: 'back.events.ventas',
                                                    params: { evento_id: event.id, sesion_id: sesion.id },
                                                }" 
                                                class="btn btn-secondary ml-2 mb-2"
                                                v-if="permisos['eventos.informe']"
                                            >
                                                <i class="fas fa-ticket-alt"></i> Listado ventas
                                            </router-link>
                                            <router-link 
                                                :to="{
                                                    name: 'back.events.sesion.configuracion',
                                                    params: { evento_id: event.id, sesion_id: sesion.id },
                                                }" 
                                                class="btn btn-secondary ml-2 mb-2"
                                                v-if="permisos['eventos.crear'] || permisos['eventos.editar']"
                                            >
                                                <i class="fas fa-cogs"></i> Precios
                                            </router-link>
                                            <button 
                                                class="btn btn-secondary ml-2 mb-2" 
                                                v-on:click="$modal.show('descargar-plano-pdf')"
                                                v-if="permisos['eventos.editar']"
                                            >
                                                <i class="fas fa-file-pdf"></i> Descargar plano pdf
                                            </button>
                                            <DescargarPlanoPdf name="descargar-plano-pdf" :evento="event" :sesion_id="sesion.id" v-on:close="$modal.hide('descargar-plano-pdf')" />
                                            <router-link 
                                                :to="{
                                                    name: 'back.events.sesion.informe.control-acceso',
                                                    params: { evento_id: event.id, sesion_id: sesion.id },
                                                }" 
                                                class="btn btn-secondary ml-2 mb-2"
                                                v-if="permisos['eventos.informe'] && !isTaquilleroVisitante"
                                            >
                                                INFORME CONTROL DE ACCESOS
                                            </router-link>
                                            <router-link 
                                                :to="{
                                                    name: 'back.events.sesion.control-acceso',
                                                    params: { evento_id: event.id, sesion_id: sesion.id, codigo_evento: event.codigo },
                                                }" 
                                                class="btn btn-secondary ml-2 mb-2"
                                            >
                                                CONTROL DE ACCESO
                                            </router-link>
                                            <router-link 
                                                :to="{
                                                    name: 'back.events.sesion.productos',
                                                    params: { evento_id: event.id, sesion_id: sesion.id },
                                                }" 
                                                class="btn btn-secondary ml-2 mb-2"
                                                v-if="permisos['eventos.editar']"
                                            >
                                                Productos
                                            </router-link>
                                            <router-link 
                                                :to="{
                                                    name: 'back.events.sesion.compradores-permitidos',
                                                    params: { evento_id: event.id, sesion_id: sesion.id },
                                                }" 
                                                class="btn btn-secondary ml-2 mb-2"
                                                v-if="permisos['eventos.editar'] && event.compra_privada"
                                            >
                                                Compradores permitidos
                                            </router-link>
                                            <DescargarInformeControlAcceso name="descargar-informe-control" :evento="event" :sesion_id="sesion.id" :taquillero_id="null" v-on:close="$modal.hide('descargar-informe-control')" />
                                            <button 
                                                class="btn btn-secondary ml-2 mb-2" 
                                                v-on:click.prevent="showModalEditarSesion(sesion, event)"
                                                v-if="permisos['eventos.editar']"
                                            >
                                                <i class="fas fa-edit"></i> Editar
                                            </button>
                                            <button 
                                                class="btn btn-secondary ml-2 mb-2" 
                                                v-on:click.prevent="showModalBorrarSesion(sesion, event)"
                                                v-if="permisos['eventos.editar']"
                                            >
                                                <i class="fas fa-trash"></i> Borrar
                                            </button>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <CrearSesionModal v-if="active_event" :evento="active_event" v-on:close="closeModal"/>
            <EditarSesionModal v-if="active_sesion" :sesion="active_sesion" :evento="active_event" v-on:close="closeModal"/>
            <DeleteSesionModal v-if="active_sesion" :sesion="active_sesion" :evento="active_event" v-on:close="closeModal"/>
            <CambiarImagen v-if="active_event && (permisos['eventos.editar'] || permisos['eventos.crear'])" :evento="active_event" @close="closeModal"/>
            <hr />
            <div class="row justify-content-between">
                <div class="col-12 col-lg-3">
                    <ElementosPorPaginaComponent v-model="filters.per_page"/>
                </div>
                <div class="col-12 col-lg-4" v-if="events">
                    <PaginateComponent 
                        :current_page="events.meta.current_page" 
                        :last_page="events.meta.last_page"
                        v-on:change_page="setPage"
                    />
                </div>
            </div>
        </div>
        <div class="card-body" v-else>
            <LoaderComponent/>
        </div>
    </div>
</template>

<script>
    import LoaderComponent from "@/components/preloader/LoaderComponent";
    import PaginateComponent from "@/components/table/pagination/BackPaginateComponent";
    import DeleteEventModal from "@/views/backend/events/modals/DeleteEventModal";
    import DeleteSesionModal from "@/views/backend/events/modals/DeleteSesionModal";
    import CrearSesionModal from "@/views/backend/events/modals/CrearSesionModal";
    import EditarSesionModal from "@/views/backend/events/modals/EditarSesionModal";
    import OpcionesDropdownComponent from "@/components/backend/components/OpcionesDropdownComponent";
    import SearchComponent from "@/components/backend/components/SearchComponent";
    import ElementosPorPaginaComponent from "@/components/backend/components/ElementosPorPaginaComponent";
    import CambiarImagen from "@/components/backend/eventos/CambiarImagen";
    import DescargarInformeControlAcceso from '../../../views/backend/events/modals/DescargarInformeControlAcceso';
    import DescargarPlanoPdf from "@/views/backend/events/modals/DescargarPlanoPdf.vue";

    export default {
        data() {
            return {
                events: { data: [], meta: { current_page: 1 } },
                expand: [],
                loading: true,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: "",
                    e: "actuales",
                },
                active_event: null,
                active_sesion: null,
                active_cambiar_imagen: null,
            };
        },
        created() {
            this.debouncedGetEvents = _.debounce(this.getEvents, 500);
            this.getEvents();
        },
        computed: {
            permisos() {
                return this.$store.getters.getPermisos;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            isTaquilleroVisitante() {
                return this.$store.getters.getUser.role === 11;
            },
        },
        mounted: function() { },
        watch: {
            "filters.search"() {
                this.debouncedGetEvents();
            },
            "filters.per_page"() {
                this.debouncedGetEvents();
            },
        },
        methods: {
            async getUrlEvent(event, sesion) {
                var url = "";
                if (event.slug) {
                    url = process.env.VUE_APP_CLE_FRONT + "event/" + event.slug;
                } else {
                    url = this.footer.url_gracias + "eventos/" + event.id + "/" + sesion.id;
                }

                navigator.clipboard.writeText(url);
                this.$toast.success("Url copiada!");
            },
            openTestTab(event, sesion) {
                if (!event.solo_abonados) {
                    this.$router.push(`/eventos/${event.id}/${sesion.id}/${event.slug}?venta_online=test`);
                } else {
                    this.$router.push(`/eventos/${event.id}/${sesion.id}/abonados?venta_online=test`);
                }
            },
            showModalPdfSesion(sesion, evento) {
                this.active_sesion = sesion;
                this.active_event = evento;
                this.$nextTick(() => {
                    this.$modal.show("plano-pdf-" + sesion.id + evento.id);
                });
            },
            showModalEditarSesion(sesion, evento) {
                this.active_sesion = sesion;
                this.active_event = evento;
                this.$nextTick(() => {
                    this.$modal.show("editar-sesion-" + sesion.id);
                });
            },
            showModalBorrarSesion(sesion, evento) {
                this.active_sesion = sesion;
                this.active_event = evento;
                this.$nextTick(() => {
                    this.$modal.show("borrar-sesion-" + sesion.id);
                });
            },
            showCrearSesion(event) {
                this.active_event = event;
                this.$nextTick(() => {
                    this.$modal.show("crear-sesion");
                });
            },
            getEvents: function() {
                this.loading = true;
                const data = {
                    filters: this.filters,
                };
                this.$store
                    .dispatch(this.config.getVuexAlias("back.events.index"), data)
                    .then(res => {
                        this.events = res.data;
                        this.loading = false;
                    })
                    .catch(error => {
                        console.log(error);
                        this.loading = false;
                    });
            },
            expandir(index) {
                if (this.expand.indexOf(index) >= 0) {
                    this.expand.splice(this.expand.indexOf(index), 1);
                } else {
                    this.expand.push(index);
                }
            },
            setPage(page) {
                this.filters.page = page;
                this.getEvents();
            },
            showModal(modal) {
                this.expand = [];
                this.$modal.show(modal);
            },
            closeModal(modal, borrado) {
                this.active_sesion = null;
                this.active_event = null;
                this.$modal.hide(modal);
                if (borrado) {
                    this.getEvents();
                }
            },
            showModalCambiarImagen(evento) {
                this.active_event = evento;
                this.$nextTick(() => {
                    this.$modal.show("cambiar-imagen-" + evento.id);
                });
            },
        },
        components: {
            SearchComponent,
            LoaderComponent,
            PaginateComponent,
            DeleteEventModal,
            CrearSesionModal,
            EditarSesionModal,
            DeleteSesionModal,
            OpcionesDropdownComponent,
            ElementosPorPaginaComponent,
            CambiarImagen,
            DescargarInformeControlAcceso,
            DescargarPlanoPdf
        },
    };
</script>

<style scoped>
    .btn {
        margin: 1% auto;
    }

    .color-gray {
        background-color: #F0F0F0;
        padding: 2% 4%;
        border-radius: 8px;
        border: 2px solid white;
        margin-bottom: 4px;
    }

    .pdng-right {
        padding-right: 4%;
    }
    @media (max-width: 768px) {
        .float-right {
            float: left !important;
            margin-left: 4px;
        }

        .crearEvento {
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .ml-2 {
            margin: 5px;
            float: left; 
        }

        .packs-eventos {
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    @media only screen and (min-width: 768px) {
        .margin-right-20 {
            margin-right: 20px !important;
        }
    }
</style>